import axios from 'axios';
import { errorHelper, messageHelper } from '../helper.js';
import {
  GET_LIST_INVITATION_URL,
  INVITATION_AVAILABLE_ACTIONS_URL,
} from '../../../vars';

/**
 * @namespace Invitation
 * @description  -
 */
export default {
  state: {
    currentInvitation: null

  },

  mutations: {
    UPDATE_INVITATION_ALL(state, data) {
      state.currentInvitation = data;
    },
  },

  actions: {
      /**
       * Получает список данных по ролям(moderator)
       * @param {Object} ctx
       * @param {Object} data Данные для получания списка по ролям
       * @returns {Object} Данные резьтатат запроса
       * @throws {Object} Ошибка запроса данных
       *
       * @memberof RoleList
       */
    async GET_LIST_INVITATION(ctx, data) {
      // let allUrl = `${GET_LIST_COUNCILS_URL}?status_id=${data.status_id}`;

      try {
        // console.log('GET_LIST_COUNCILS', data)
          const res = await axios.post(`${GET_LIST_INVITATION_URL}`, data,{ headers: {
                Authorization: `Token ${localStorage.token}`
          }});
          return res
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          throw e
      }
    },


    async UPDATE_INVITATION(ctx, data) {
      // let allUrl = `${GET_LIST_COUNCILS_URL}?status_id=${data.status_id}`;

      try {
        // console.log('GET_LIST_COUNCILS', data)
          const res = await axios.post(`${INVITATION_AVAILABLE_ACTIONS_URL}`, data,{ headers: {
                Authorization: `Token ${localStorage.token}`
          }});
          return res.data
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          throw e
      }
    },



    /**
     * NEW COUNCIL
     * @param {Object} ctx
     * @param {Object} data Данные для NEW COUNCIL
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof User
     */
    async NEW_INVITATION(ctx, data) {
      try {
        const res = await axios.patch(`${GET_LIST_INVITATION_URL}`, data, {headers: {
              Authorization: `Token ${localStorage.token}`,
          }});
        return res.data
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          console.log('NEW_INVITATION', e)
          throw e
      }
    },


    /**
     * Получает детальную информацию и записывает
     * @param {Object} ctx
     * @param {String|Number} id Идентификатор
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async GET_INVITATION_ALL(ctx, id) {
      try {
        const res = await axios.get(`${GET_LIST_INVITATION_URL}?id=${id}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        await ctx.commit('UPDATE_INVITATION_ALL', res.data);

        return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' GET_INVITATION_ALL');
        throw e;
      }
    },


    /**
     * export to file
     * @param {Object} ctx
     * @param {Array|Object} data список идентификаторов
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async INVITATION_MAKE_ACTION(ctx, data) {
      try {
        const res = await axios.post(`${INVITATION_AVAILABLE_ACTIONS_URL}`, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
          return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' INVITATION_MAKE_ACTION');
        throw e;
      }
    },


        /**
     * Получает список доступных действий в Invitation
     * @param {Object} ctx
     * @param {String} data invitation_id
     * @returns {object} Список доступных действий
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     *
     */
        async GET_INVITATION_AVAILABLE_ACTIONS(ctx, data) {
          try {
            const res = await axios.get(`${INVITATION_AVAILABLE_ACTIONS_URL}?id=${data}`, {
              headers: {
                Authorization: `Token ${localStorage.token}`,
              },
            });
            return res.data
          } catch (e) {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
            throw e;
          }
        },

},

  getters: {
    GETTERS_INVITATION_ALL(state) {
      return state.currentInvitation;
    },

  },
};
